import React from 'react';
import { FeatureFlagOnProps } from './types';

export default class FeatureFlagOn extends React.Component<FeatureFlagOnProps> {
  render() {
    return this.props.children || null;
  }
}
